'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward } from '@awesome.me/kit-94e593bf23/icons/classic/light';
import Tooltip from '@/app/_components/Tooltip';
import ProductFavoriteMarker from '@/app/_components/ProductFavoriteMarker';
import { decodeEntities } from '@/app/_lib/services/ClientUtil';
import Price from '@/app/_components/Price';
import { useHmSpecialSale, isHmSpecialSaleProduct } from '@/app/_lib/hooks/useHmSpecialSale';
import '@/app/_styles/sale.css';
const capitalize = str => str ? str.charAt(0).toUpperCase() + str.slice(1) : '';

// className="border min-w-[150px] min-h-[150px] transition-all duration-500 scale-100 group-hover:scale-110 mx-auto"

const ProductListing = t0 => {
  const $ = _c(67);
  const {
    product,
    hideDetails,
    className,
    specialSaleMessage: t1
  } = t0;
  const specialSaleMessage = t1 === undefined ? false : t1;
  const specialSale = useHmSpecialSale(specialSaleMessage);
  const [isBestSellerHovered, setIsBestSellerHovered] = useState(false);
  if (!(product.product_photo || product.thumb_1)) {
    return null;
  }
  let imageSrc;
  if (product.file_name) {
    imageSrc = `${process.env.NEXT_PUBLIC_RESOURCE_URL}/${product.file_name}`;
  } else {
    if (product.thumb_1) {
      imageSrc = `${process.env.NEXT_PUBLIC_RESOURCE_URL}/thumbs/${product.thumb_1}`;
    } else {
      imageSrc = `${process.env.NEXT_PUBLIC_RESOURCE_URL}/${product.product_photo}`;
    }
  }
  if (!product.url) {
    return null;
  }
  const t2 = product.url;
  const t3 = `product-listing relative group w-full ${className ? className : ""}`;
  const t4 = product.sub_product_id;
  let t5;
  if ($[0] !== product.sub_product_name) {
    t5 = decodeEntities(product.sub_product_name);
    $[0] = product.sub_product_name;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== product.sub_product_id || $[3] !== t5) {
    t6 = <ProductFavoriteMarker sub_product_id={t4} productName={t5} />;
    $[2] = product.sub_product_id;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== isBestSellerHovered || $[6] !== product.is_best_seller || $[7] !== product.sub_product_name) {
    t7 = product.is_best_seller === 1 && <Tooltip content={`The ${capitalize(decodeEntities(product.sub_product_name))} is a best seller.`} side="top" onOpenChange={setIsBestSellerHovered}><span className="relative visible [@media(hover:hover)]:lg:invisible [@media(hover:hover)]:lg:group-hover:visible"><FontAwesomeIcon icon={faAward} className={`${isBestSellerHovered ? "text-primary" : "text-light"} transition-colors text-xl`} /></span></Tooltip>;
    $[5] = isBestSellerHovered;
    $[6] = product.is_best_seller;
    $[7] = product.sub_product_name;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <div className="absolute z-40 bottom-3 left-3 flex items-center gap-4">{t6}{t7}</div>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== product.designer_name || $[13] !== product.product_name || $[14] !== product.sub_product_name || $[15] !== product.supplier_name) {
    t9 = decodeEntities(product.sub_product_name) || product.product_name || `${product.supplier_name || ""} ${product.designer_name || ""} product`.trim() || "Product image";
    $[12] = product.designer_name;
    $[13] = product.product_name;
    $[14] = product.sub_product_name;
    $[15] = product.supplier_name;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== imageSrc || $[18] !== t9) {
    t10 = <div className="overlay-block bg-white flex-1 flex items-center justify-center"><Image className="object-contain scale-75 sm:scale-85 lg:scale-100 lg:transition-all lg:duration-400 lg:group-hover:scale-105 " src={imageSrc} overrideSrc={imageSrc} alt={t9} placeholder="blur" blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPcIgkAAYcAz3yXgHoAAAAASUVORK5CYII=" width={160} height={160} quality={90} sizes="160px" /></div>;
    $[17] = imageSrc;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t8) {
    t11 = <div className="aspect-square bg-gray-3 p-3 flex flex-col relative">{t8}{t10}</div>;
    $[20] = t10;
    $[21] = t8;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const t12 = `z-10 text-left min-h-16 mt-3 ${hideDetails ? "hidden lg:block transition-opacity duration-400 opacity-0 lg:group-hover:opacity-100 lg:group-hover:bottom-3" : ""}`;
  let t13;
  if ($[23] !== product.discount_percentage || $[24] !== product.is_tier_promo || $[25] !== product.on_sale) {
    t13 = product.on_sale == 1 && product.discount_percentage > 0 && <div className="text-2xs mb-3 text-red">{!product.is_tier_promo && <span className="font-semibold">Sale </span>}{product.discount_percentage}% off</div>;
    $[23] = product.discount_percentage;
    $[24] = product.is_tier_promo;
    $[25] = product.on_sale;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== product.sub_product_name) {
    t14 = decodeEntities(product.sub_product_name);
    $[27] = product.sub_product_name;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t14) {
    t15 = <div className="product-name capitalize font-medium text-sm mb-3">{t14}</div>;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== product.highest_price || $[32] !== product.lowest_price || $[33] !== product.original_highest_price || $[34] !== product.original_lowest_price || $[35] !== product.original_price || $[36] !== product.retail_price) {
    t16 = Number(product.lowest_price) > 0 && Number(product.highest_price) > 0 && Number(product.highest_price) > Number(product.lowest_price) ? <div className="capitalize font-light text-sm"><span className={product.original_lowest_price ? "text-dark" : ""}><Price amount={product.lowest_price} /> - <Price amount={product.highest_price} /></span>{product.original_lowest_price && <div className="line-through text-light text-2xs"><Price amount={product.original_lowest_price} /> - <Price amount={product.original_highest_price} /></div>}</div> : <div className="capitalize font-light text-sm"><span className={product.original_price ? "text-dark" : ""}><Price amount={product.retail_price} /></span>{product.original_price && <div className="line-through text-light text-2xs"><Price amount={product.original_price} /></div>}</div>;
    $[31] = product.highest_price;
    $[32] = product.lowest_price;
    $[33] = product.original_highest_price;
    $[34] = product.original_lowest_price;
    $[35] = product.original_price;
    $[36] = product.retail_price;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== product || $[39] !== specialSale || $[40] !== specialSaleMessage) {
    t17 = specialSaleMessage && isHmSpecialSaleProduct(product, specialSale) && <div className="text-2xs text-red mt-1">Save 20% With Code HM20</div>;
    $[38] = product;
    $[39] = specialSale;
    $[40] = specialSaleMessage;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== product.shipping) {
    t18 = product.shipping?.product_listing_message?.length > 0 && <div className="text-3xs text-light">{product.shipping.product_listing_message}</div>;
    $[42] = product.shipping;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t16 || $[45] !== t17 || $[46] !== t18) {
    t19 = <div className="mb-3">{t16}{t17}{t18}</div>;
    $[44] = t16;
    $[45] = t17;
    $[46] = t18;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  const t20 = `capitalize text-3xs font-medium ${product.designer_name ? "mb-1 xs:mb-0 xs:border-r-1 xs:pr-2" : ""}`;
  let t21;
  if ($[48] !== product.supplier_name || $[49] !== t20) {
    t21 = <div className={t20}>{product.supplier_name}</div>;
    $[48] = product.supplier_name;
    $[49] = t20;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== product.designer_name) {
    t22 = <div className="capitalize text-3xs text-light">{product.designer_name}</div>;
    $[51] = product.designer_name;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== t21 || $[54] !== t22) {
    t23 = <div className="flex flex-col xs:flex-row xs:items-center justify-start xs:space-x-2">{t21}{t22}</div>;
    $[53] = t21;
    $[54] = t22;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== t12 || $[57] !== t13 || $[58] !== t15 || $[59] !== t19 || $[60] !== t23) {
    t24 = <div className={t12}>{t13}{t15}{t19}{t23}</div>;
    $[56] = t12;
    $[57] = t13;
    $[58] = t15;
    $[59] = t19;
    $[60] = t23;
    $[61] = t24;
  } else {
    t24 = $[61];
  }
  let t25;
  if ($[62] !== product.url || $[63] !== t11 || $[64] !== t24 || $[65] !== t3) {
    t25 = <Link href={t2} scroll={true} className={t3}>{t11}{t24}</Link>;
    $[62] = product.url;
    $[63] = t11;
    $[64] = t24;
    $[65] = t3;
    $[66] = t25;
  } else {
    t25 = $[66];
  }
  return t25;
};
export default ProductListing;